<template>
<div class="chapter">
<div class="inner_page">
<p class="noindent2"> </p>
<p class="noindent2"> </p>
<p class="noindent"><a id="ch00_fm03_copy"></a><a id="page_iv"></a>International Standard Book Number<br/>0-292-78425-2 (paper)<br/>Library of Congress Catalog Card Number 60-14312<br/>Copyright © 1961 by the University of Texas Press<br/>All rights reserved<br/>Printed in the United States of America</p>
<p class="noindent2">Thirteenth paperback printing, 2002</p>
<p class="noindent2">Requests for permission to reproduce material from this work should be sent to Permissions, University of Texas Press, Box 7819, Austin, Texas 78713-7819.</p>
<p class="noindent2"><img alt="image" src="images/f00iv-01.jpg"/> The paper used in this publication meets the minimum requirements of American National Standard for Information Sciences—Permanence of Paper for Printed Library Materials, ANSI Z39.48-1984.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm03_copy.vue?e2e4a97e